import { createProviderRegistry } from '../createProviderRegistry'
import { agoraRtcAdapter } from './agora'

export function createRtcProviderRegistry({ providers = [] } = {}) {
  const registry = createProviderRegistry('rtc')

  ;[agoraRtcAdapter, ...providers].forEach((provider) => {
    if (provider) {
      registry.register(provider)
    }
  })

  return registry
}
